// Progressive enhancement: AJAX add-to-cart for product form
(function(){
  const root = document;
  const forms = root.querySelectorAll('.product-form__form');
  if (!forms.length) return;

  // Utility to format money using Liquid-rendered formatter via a hidden element if needed
  const formatMoney = (cents, currency) => {
    try {
      const amount = (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency || document.documentElement?.dataset?.currency || 'USD' });
      return amount;
    } catch { return (cents / 100).toFixed(2); }
  };

  // Variant change handling per form
  for (const form of forms) {
    const container = form.closest('.product-form');
    const variantSelect = form.querySelector('#variant-select');
    const priceEl = container?.previousElementSibling?.querySelector('.price');
    // The price snippet renders before the form inside .product-form root
    const priceRoot = container?.querySelector('.price') || container?.querySelector('[data-price]');
    const availability = container?.querySelector('.product-form__availability');
    const availText = container?.querySelector('.product-form__availability-text');
    const availDot = container?.querySelector('.availability-dot');
    const addBtn = container?.querySelector('.product-form__add');
    const currency = container?.getAttribute('data-currency') || (root.documentElement.getAttribute('lang') === 'da' ? 'DKK' : 'EUR');
  const variantsScript = container?.querySelector('script[data-variants]');
  const vatRate = parseFloat(container?.getAttribute('data-vat-rate') || '25');
  const taxesIncluded = String(container?.getAttribute('data-taxes-included') || '').toLowerCase() === 'true';
    let variants = [];
    try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch {}

    const updateUIForVariant = (variantId) => {
      if (!variantId) return;
      const v = variants.find(x => String(x.id) === String(variantId));
      if (!v) return;
      // Price update (supports compare_at)
      if (priceRoot) {
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceRoot.classList.toggle('price--sale', !!onSale);
        const current = priceRoot.querySelector('.price__current');
        const compare = priceRoot.querySelector('.price__compare');
        if (current) current.textContent = formatMoney(v.price, currency);
        if (compare) {
          if (onSale) { compare.textContent = formatMoney(v.compare_at_price, currency); }
          else { compare.textContent = ''; }
        }

        // VAT details update
        const vatGroup = priceRoot.querySelector('.price__vat-group');
        if (vatGroup) {
          const denom = 100 + (isFinite(vatRate) ? vatRate : 25);
          const priceInc = taxesIncluded ? v.price : Math.round(v.price * denom / 100);
          const priceEx = taxesIncluded ? Math.round(v.price * 100 / denom) : v.price;
          const exAmt = vatGroup.querySelector('.price__vat-amount[data-vat-part="ex"]');
          const incAmt = vatGroup.querySelector('.price__vat-amount[data-vat-part="inc"]');
          if (exAmt) exAmt.textContent = formatMoney(priceEx, currency);
          if (incAmt) incAmt.textContent = formatMoney(priceInc, currency);
        }
      }

      // Availability
      const inLabel = availability?.getAttribute('data-in-stock-label') || 'In stock';
      const outLabel = availability?.getAttribute('data-out-of-stock-label') || 'Not in stock';
      const isContinue = v.inventory_policy === 'continue';
      const inStock = !!(v.available || isContinue);
      if (availText) availText.textContent = inStock ? inLabel : outLabel;
      if (availDot) {
        availDot.classList.toggle('availability-dot--in', inStock);
        availDot.classList.toggle('availability-dot--out', !inStock);
      }

      // Button state and hidden id input
      const addLabel = addBtn?.getAttribute('data-add-label') || 'Add to cart';
      const soldLabel = addBtn?.getAttribute('data-sold-out-label') || 'Sold out';
      const idInput = form.querySelector('input[name="id"]');
      if (!variantSelect && idInput) idInput.value = v.id; // single-variant products
      if (addBtn) {
        if (inStock) {
          addBtn.textContent = addLabel;
          addBtn.removeAttribute('disabled');
          addBtn.type = 'submit';
        } else {
          addBtn.textContent = soldLabel;
          addBtn.setAttribute('disabled', 'true');
          addBtn.type = 'button';
        }
      }
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        updateUIForVariant(variantSelect.value);
      });
      // initial sync in case default selected changes content
      updateUIForVariant(variantSelect.value);
    }
  }

  for (const form of forms) {
	// Track which button triggered submit so we can
	// let "Buy now" go directly to checkout.
	const submitButtons = form.querySelectorAll('button[type="submit"]');
	submitButtons.forEach((btn) => {
	  btn.addEventListener('click', () => { form._lastSubmitter = btn; }, { capture: true });
	});

    form.addEventListener('submit', async (e) => {
      // Respect modifier-clicks or if JS disabled
      if (e.defaultPrevented) return;

	  const submitter = e.submitter || form._lastSubmitter || form.querySelector('.product-form__add');
	  const isBuyNow = !!(submitter && (submitter.classList?.contains('product-form__buy') || submitter.name === 'checkout'));
	  // For "Køb nu" button let the native Shopify behavior
	  // handle the submit so it goes straight to checkout.
	  if (isBuyNow) return;

      e.preventDefault();

      const submitBtn = form.querySelector('.product-form__add');
      const statusEl = form.parentElement.querySelector('.product-form__status');
      const addedLabel = statusEl?.getAttribute('data-added-label') || 'Added to cart';
      const errorLabel = statusEl?.getAttribute('data-error-label') || 'Could not add to cart';

      const fd = new FormData(form);
      // Build cart/add payload
      const payload = { items: [{
        id: fd.get('id'),
        quantity: parseInt(fd.get('quantity') || '1', 10)
      }]};

      try {
        submitBtn?.setAttribute('disabled', 'true');
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'same-origin'
        });
        if (!res.ok) throw new Error('Add-to-cart failed');
        statusEl && (statusEl.textContent = addedLabel);
        statusEl && statusEl.classList.add('product-form__status--ok');
        // Dispatch custom event for cart recommendation popup
        window.dispatchEvent(new CustomEvent('cart:item-added', { detail: { productId: fd.get('id') } }));
        // Optionally update cart count optimistically
        const countEls = root.querySelectorAll('[data-cart-count]');
        for (const el of countEls) {
          const current = parseInt(el.textContent || '0', 10) || 0;
          const next = current + payload.items[0].quantity;
          el.textContent = String(next);
          if (next > 0) el.classList.add('is-visible');
        }
        // Show global toast if present
        const toast = root.getElementById('Toast');
        if (toast) {
          toast.textContent = addedLabel;
          toast.hidden = false;
          toast.classList.add('toast--show');
          setTimeout(() => {
            toast.classList.remove('toast--show');
          }, 2200);
        }
        // Clear status after a while
        setTimeout(() => {
          statusEl && (statusEl.textContent = '');
          statusEl && statusEl.classList.remove('product-form__status--ok');
        }, 2500);
      } catch (err) {
        statusEl && (statusEl.textContent = errorLabel);
        statusEl && statusEl.classList.add('product-form__status--error');
        setTimeout(() => {
          statusEl && (statusEl.textContent = '');
          statusEl && statusEl.classList.remove('product-form__status--error');
        }, 3000);
      } finally {
        submitBtn?.removeAttribute('disabled');
      }
    });
  }
})();
